export const storeProducts = [
  {
    id: 1,
    title: 'Nike Air Max Plus',
    img: 'img/product1.jpg',
    price: 169.99,
    company: 'Nike',
    info:
      "Let your attitude have the edge in the Nike Air Max Plus, a Tuned Air experience that offers premium stability and unbelievable cushioning. Featuring gradient colouring inspired by flames and the OG's wavy design lines, it celebrates defiant style.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 2,
    title: 'Air Jordan 1 Low Premium',
    img: 'img/product2.jpg',
    price: 129.99,
    company: 'Nike',
    info: "When a shoe meets greatness. The Air Jordan 1 Low is inspired by the 1985 original. It offers a clean, classic look in a low-cut silhouette that's perfect for casual wear.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 3,
    title: 'Nike Air Max Plus',
    img: 'img/product3.jpg',
    price: 169.99,
    company: 'Nike',
    info: "Let your attitude make a splash with the Nike Air Max Plus, a Tuned Air experience offering premium stability and support. Featuring crisp neutral colours and the OG's wavy design lines, it celebrates the past while taking you boldly into the future.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 4,
    title: 'Nike SuperRep Go',
    img: 'img/product4.jpg',
    price: 99.99,
    company: 'Nike',
    info: "The Nike SuperRep Go combines comfortable foam cushioning, flexibility and support to get you moving in circuit-based fitness classes or while streaming workouts at home.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 5,
    title: 'Nike Air Max Plus',
    img: 'img/product5.jpg',
    price: 169.99,
    company: 'Nike',
    info: "The Nike Air Max Plus brings you a legendary Tuned Air experience that offers premium stability and cushioning. The original design was inspired by palm trees and a whale's tail, but this edition features icy, gradient tones reminiscent of polar landscapes for a cool new take on the OG.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 6,
    title: 'Nike Mercurial Vapor 13 Elite MDS FG',
    img: 'img/product6.jpg',
    price: 269.99,
    company: 'Nike',
    info: "Dream of speed and play fast in the Nike Mercurial Vapor 13 Elite MDS FG. A streamlined upper combines with a Nike Aerowtrac zone for high-speed play and supercharged traction.",    
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 7,
    title: 'Nike Air Zoom Pegasus 37',
    img: 'img/product7.jpg',
    price: 119.99,
    company: 'Nike',
    info: "Reinvigorate your stride with the Nike Air Zoom Pegasus 37. Delivering the same fit and feel that runners love, the shoe has an all-new forefoot cushioning unit and foam for maximum responsiveness. The result is a durable, lightweight trainer designed for everyday running.",
    inCart: false,
    count: 0,
    total: 0,
  },
  {
    id: 8,
    title: 'Air Jordan 1 Mid SE',
    img: 'img/product8.jpg',
    price: 129.99,
    company: 'Nike',
    info: "The Air Jordan 1 Mid SE maintains the timeless appeal of the first AJ1, revamped with fresh colours to give it an updated profile. It has a lightweight Air-Sole unit and a mix of natural and synthetic materials that make up its classic look.",
    inCart: false,
    count: 0,
    total: 0,
  },
];

export const detailProduct = {
  id: 1,
  title: 'Google Pixel - Black',
  img: 'img/product-1.png',
  price: 10,
  company: 'google',
  info:
    'Lorem ipsum dolor amet offal butcher quinoa sustainable gastropub, echo park actually green juice sriracha paleo. Brooklyn sriracha semiotics, DIY coloring book mixtape craft beer sartorial hella blue bottle. Tote bag wolf authentic try-hard put a bird on it mumblecore. Unicorn lumbersexual master cleanse blog hella VHS, vaporware sartorial church-key cardigan single-origin coffee lo-fi organic asymmetrical. Taxidermy semiotics celiac stumptown scenester normcore, ethical helvetica photo booth gentrify.',
  inCart: false,
  count: 0,
  total: 0,
};
